export default __webpack_public_path__ + "static/media/admob-interstitial.59564b18.png";